import { useContext, useEffect, useState } from "react";
import { usePageMetadata } from "../../../../context/PageMetadata";
import { getExpectedBetaPath } from "../getExpectedBetaPath";
import { useUserStatus } from "./useUserStatus";
import { isFullScreenRoute } from "../isFullScreenRoute";
import { BETA_BASE_ROUTE } from "../constants";
import { ExecutionContext } from "../../../../providers/ExecutionContextProvider";
export const useBetaHubRouter = ({ campaignID }) => {
    const { locale } = usePageMetadata();
    const { isLoading, userStatus, inviteCode, betaKey } = useUserStatus({ campaignID });
    const [isFullScreen, setFullScreen] = useState(false);
    const [isAllowedRoute, setIsAllowedRoute] = useState(false);
    const executionContext = useContext(ExecutionContext);
    useEffect(() => {
        const betaBaseRoute = `${BETA_BASE_ROUTE}/${locale}`;
        let redirectRoute = "";
        if (!isLoading) {
            const currentPath = window.location.pathname.replace(betaBaseRoute, "");
            const expectedPathName = getExpectedBetaPath({
                userStatus,
                hasInviteCode: !!inviteCode,
                currentPath,
                campaignID,
                platform: window?.navigator.userAgent,
            });
            if (currentPath !== expectedPathName && currentPath !== `${expectedPathName}/` && !process.env.STORYBOOK) {
                redirectRoute = `${betaBaseRoute}${expectedPathName}`;
            }
            if (redirectRoute) {
                window.location.pathname = redirectRoute;
            }
            else {
                setFullScreen(isFullScreenRoute(currentPath));
                setIsAllowedRoute(true);
            }
        }
    }, [locale, isLoading, userStatus, inviteCode, setIsAllowedRoute, campaignID]);
    const isPageLoading = isLoading || !isAllowedRoute;
    const devContext = executionContext === "storybook" || executionContext === "test";
    return {
        isLoading: devContext ? false : isPageLoading,
        isAllowedRoute: devContext || isAllowedRoute,
        isFullScreen,
        inviteCode,
        betaKey,
        locale,
    };
};
//# sourceMappingURL=useBetaHubRouter.js.map